/**
 * Core global JS.
 */
// Instantiate components
// Components
import { ComponentManager } from 'js-component-framework';
import header from 'components/header';
import menu from 'components/menu';
import carousel from 'components/carousel';
import cookiesBanner from 'components/cookies-banner';

import 'components/footer';

// Import SCSS
import 'scss/index.scss';

// Components used by this entry
const components = [
  menu,
  header,
  carousel,
  cookiesBanner,
];

// Create instance of the component manager using `aam-meeting`
const manager = new ComponentManager('aam-meeting');

// Initialize components
document.addEventListener('DOMContentLoaded', () => {
  manager.initComponents(components); // You can supply an array of configurations to start many components at once
});

if (module.hot) {
  module.hot.accept();
  // This is required for HMR, otherwise you'll need to refresh
  // the page to see JS changes
  manager.initComponents(components);
}
